import { useAppSelector } from '../../../store';
import getSpinResultInfo from '../utils/getSpinResultInfo';
import { useEnergyContext } from '../../../providers/EnergyProvider';

type SpinResultProps = {
  isSpinning: boolean
}
function SpinResult({ isSpinning }: SpinResultProps) {
  const { maxEnergy } = useEnergyContext();
  const { slotMachineSpin } = useAppSelector(
    ({ aviator }) => aviator,
  );

  const effect = slotMachineSpin?.effects[0];

  const { icon, label } = getSpinResultInfo({
    effect,
    energy: (maxEnergy / 100) * (effect?.amount ?? 0), // calculate % of regenerated energy
    isSpinning,
  });

  if (isSpinning) {
    return null;
  }
  return (
    <div className="flex items-center justify-center text-xs gap-1">
      <span>
        {icon}
      </span>
      <span className="font-Bangers">
        {label}
      </span>
    </div>
  );
}

export default SpinResult;
